import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LoginPinComponent} from "./login-pin.component";

const routes: Routes = [{path: 'pin/:hash', component: LoginPinComponent}];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class LoginRoutingModule {
}
